<template>
  <!-- 刻度 -->
  <div class="scale">
    <div class="scale__description">
      <a-date-picker
        placeholder="选择日期"
        :disabled-date="disabledDate"
        :locale="locale"
        @change="changeDate"
      >
        <span style="cursor:pointer;">{{ date }}</span>
      </a-date-picker>
    </div>
    <div class="scale__times">
      <div class="scale__time" v-for="oclock in 24" :key="oclock">
        {{ formatOclock(oclock - 1) }}:00
        <a-icon type="caret-right" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";

export default {
  data() {
    return {
      locale
    };
  },
  computed: {
    date() {
      return (
        new Date(this.visibleDays[0]).getFullYear() +
        "年" +
        (new Date(this.visibleDays[0]).getMonth() + 1) +
        "月"
      );
    },
    ...mapGetters(["visibleDays", "originDate", "finalDate"])
  },
  methods: {
    formatOclock(oclock) {
      if (oclock < 10) {
        return "0" + oclock;
      }
      return oclock;
    },
    changeDate(day) {
      this.initVisibleDays(day); //初始化日期
    },
    disabledDate(current) {
      return current < this.originDate || current > this.finalDate;
    },
    ...mapMutations(["initVisibleDays"])
  }
};
</script>

<style>
.scale {
  display: flex;
  flex-flow: column;
  position: absolute;
  top: 0;
  height: 100%;
  background-color: #fff;
  user-select: none;
  border-right: 1px solid #dee0e3;
}

.scale__times {
  flex: 1;
  height: 100%;
  display: grid;
  grid-template-rows: repeat(24, minmax(22px, 1fr));
  bottom: 2rem;
  padding-left: 1rem;

  margin-top: -0.7rem;
  margin-bottom: 0.7rem;
  color: #8f959e;
}

.scale__time {
  margin-right: -1rem;
}

.scale__times i {
  color: black;
}
.scale__description {
  flex: 0 0 13.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
  text-align: center;
  font-size: 1.5rem;
  user-select: none;
  cursor: pointer;
}
</style>
